import {uploadImagesService} from '@/services/uploadImages'
import {useRef, useState} from 'react'

export const useImagesUpload = () => {
  const [uploading, setUploading] = useState(false)
  const [progress, setProgress] = useState(0)
  const [uploadErrors, setUploadErrors] = useState([])
  const [, setIsSingleImgUpload] = useState(false)
  const [prodIds, setAllProdIds] = useState([])
  const activeUploadsRef = useRef(0)

  const onUploadProgress = progressEvent => {
    const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    setProgress(progress)
  }

  const startUpload = () => {
    activeUploadsRef.current += 1
    setUploading(true)
  }

  const finishUpload = () => {
    activeUploadsRef.current = Math.max(0, activeUploadsRef.current - 1)

    if (activeUploadsRef.current === 0) {
      setUploading(false)
      setProgress(0)
    }
  }

  const onUploadImages = (formData, onCallback = () => {}) => {
    startUpload()
    const imageName = formData?.get?.('images')?.name || 'image'

    return uploadImagesService({formData, onUploadProgress})
      .then(response => {
        if (response?.status === 'SUCCESS') {
          onCallback(response)
          setIsSingleImgUpload(true)

          return response
        }

        const allErrors = response?.data?.flatMap(item => item?.errors || [])
        setUploadErrors(prev => [...prev, ...allErrors])
        throw response
      })
      .catch(error => {
        const allErrors = error?.data?.data?.flatMap(item => item?.errors || [])
        const allProdIds = error?.data?.data?.flatMap(item => item?.id || [])
        setAllProdIds(prev => [...prev, allProdIds])
        const errMsg =
          error?.response?.data?.errorMessage ||
          allErrors ||
          error?.data?.message ||
          error?.message ||
          `An unknown error occurred uploading ${imageName}`
        const errorMessages = Array.isArray(errMsg) ? errMsg : [errMsg]
        setUploadErrors(prev => [...prev, ...errorMessages])
        throw error
      })
      .finally(() => {
        finishUpload()
      })
  }

  return {
    onUploadImages,
    uploading,
    progress,
    uploadErrors,
    setUploadErrors,
    setIsSingleImgUpload,
    setAllProdIds,
    prodIds,
  }
}
